import { render, staticRenderFns } from "./AlDropdown.vue?vue&type=template&id=3827e376&"
import script from "./AlDropdown.vue?vue&type=script&lang=js&"
export * from "./AlDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AlDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports